export enum SharingStatusEnum {
  Running = 'running',
  Success = 'success',
  Failed = 'failed',
}
